import { render, staticRenderFns } from "./MainTableAllBack.vue?vue&type=template&id=3ea92b52"
import script from "./MainTableAllBack.vue?vue&type=script&lang=js"
export * from "./MainTableAllBack.vue?vue&type=script&lang=js"
import style0 from "./MainTableAllBack.vue?vue&type=style&index=0&id=3ea92b52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports